import styled from "styled-components";
import FounderImg from "../../../assets/images/image/founder-image-1.webp";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 950px) {
    padding-bottom: 140px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;

  @media (max-width: 950px) {
    height: 600px;
    object-fit: cover;
  }
`;

const InfoWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: 2%;
  transform: translateX(-50%);

  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  align-items: center;

  max-width: 680px;

  @media (max-width: 950px) {
    left: 0;
    right: 0;
    bottom: 10px;
    transform: none;
    max-width: 100%;
    padding: 0 20px;
    text-align: justify;
    align-items: flex-end;
  }
`;

const Subtitle = styled.h3`
  font-weight: 400;
  color: ${colors.maroon};
  font-size: ${fontSize.s};
  letter-spacing: 0.04rem;
`;

const Heading = styled.h1`
  font-weight: 400;
  color: ${colors.maroon};
  font-size: ${fontSize.xl};
  letter-spacing: 0.1rem;
`;

const Paragraph = styled.p`
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.black};
  font-size: ${fontSize.xs};
`;

function StorySection() {
  return (
    <Wrapper>
      <ImageWrapper>
        <Image src={FounderImg} alt="story-of-founder" />
      </ImageWrapper>
      <InfoWrapper>
        <Subtitle>A STORY OF INDEPENDENCE</Subtitle>
        <Heading>THE FOUNDER</Heading>
        <Paragraph>
          An encounter with Himalayan herders and their centuries-old craft
          inspired our founder, revealing a tradition shaped by altitude,
          patience, and rare mountain fibers. From this moment grew a mission to
          create the finest cashmere on earth. Today, she honors the legacy with
          craftsmanship that preserves purity, mastery, and the enduring spirit
          of the high Himalayas. What began as a single journey became a
          lifelong pursuit to safeguard ancestral skill, elevate raw beauty into
          artistry, and share the quiet excellence of Himalayan cashmere with
          the world. Each piece carries the founder’s belief that true luxury is
          born not from abundance, but from devotion, heritage, and
          uncompromising care.
        </Paragraph>
      </InfoWrapper>
    </Wrapper>
  );
}

export default StorySection;
